import React from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { partnerApi } from "../../../../../services/Api/Partner/partnerApi";
import { PartnerSearchSelectApi } from "../../../../../services/Api/Partner/partnerTypes";
import { CreateLoanApi, LoanApi, OrganizationApi } from "../../../../../services/Api/types";
import { selectPartner } from "../../../../../services/partner/selectors";

interface Props {
	loan: LoanApi;
	organization?: OrganizationApi;
	adminOrOffice?: boolean;
	form: UseFormReturn<CreateLoanApi>;
	externalPartners?: PartnerSearchSelectApi[];
}

const NewLoanPreviewBasicInfoCard = ({ loan, organization, adminOrOffice, form, externalPartners }: Props) => {
	const { t } = useTranslation("admin");
	const partner = useSelector(selectPartner);
	const {
		control,
		formState: { errors },
		clearErrors,
	} = form;

	const searchPartners = async (search: string) => {
		return partnerApi.getPartnersSearchSelect(search);
	};

	const renderUser = (user: PartnerSearchSelectApi) => {
		return (
			<div className={"d-flex"}>
				{user.name} {user.email ? <small style={{ fontSize: "0.85rem" }}>&nbsp;({user.email})</small> : null}
			</div>
		);
	};

	const partnerSelect = () => {
		if (adminOrOffice)
			return (
				<FormSelectGroup
					formatOptionLabel={renderUser}
					getOptionValue={(opt) => opt.id}
					loadOptions={searchPartners}
					onChange={() => clearErrors("partner_id")}
					control={control}
					errors={errors}
					name="partner_id"
					data-testid="partner_id"
				/>
			);
		return (
			<FormSelectGroup
				getOptionLabel={(opt) => opt.name}
				defaultValue={externalPartners?.length === 1 ? externalPartners[0] : undefined}
				formatOptionLabel={renderUser}
				disabled={externalPartners?.length === 1}
				onChange={() => clearErrors("partner_id")}
				getOptionValue={(opt) => opt.id}
				control={control}
				options={externalPartners}
				errors={errors}
				name="partner_id"
				data-testid="partner_id"
			/>
		);
	};

	return (
		<Card className={"mb-3"}>
			<Card.Body>
				<h5>{t("common.word.basic_data", { ns: "lib" })}</h5>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.reference_id")}</span>
						<span>{loan.reference_id}</span>
					</div>
				</div>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("lib:common.word.location")}</span>
						<span>
							<Link
								to={`/partnership/${partner?.id}/organizations/${organization?.id}`}
								target={"_blank"}
							>
								{organization?.name}
							</Link>
						</span>
					</div>
				</div>
				<div className="card-body-item">
					<div className="item-info w-50">
						<span className="label">{t("common.word.partner")}</span>
						<span>{partnerSelect()}</span>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default NewLoanPreviewBasicInfoCard;
